import styled from 'styled-components';
import { InputText } from 'ui/inputs';
import { BasicSelect } from 'ui/selects';
import { pxToRem } from 'utils/convert';

export const TinyBasicSelect = styled(BasicSelect)`
  [role='listbox'] {
    min-width: ${pxToRem(100)};
  }
`;

export const WideInput = styled(InputText)`
  width: ${pxToRem(200)};
`;

export const SeparationText = styled.span`
  margin-left: ${pxToRem(120)};
`;
